import React from "react";
import { Link } from "react-router-dom";
export function Footer({ t }: any) {
    return (
        <footer className="footer">
            <p>&copy; {new Date().getFullYear()} MartTech. {t.footerCopyright}</p>
            <div>
                <Link to="/privacy-policy">{t.footerPrivacy}</Link> |{' '}
                <Link to="/terms-of-service">{t.footerTerms}</Link> |{' '}
                <Link to="/contact">{t.footerContact}</Link>
            </div>
        </footer>
    );
}